export default __webpack_public_path__ + "static/media/navbar-logo.5b296d11.png";